import { useEffect, useState } from 'react'

/** A useful next step once media has taken longer than an ordinary join. */
export function connectionHelp(channelJoined: boolean, waitingPeers: number, elapsedMs: number): string | null {
  if (elapsedMs < 8_000) return null
  if (!channelJoined) return 'Still connecting to this Space. Check your internet connection; we will keep trying.'
  if (waitingPeers === 0) return null
  return 'Audio and video have not connected to everyone yet. Try reconnecting. If this continues, ask your administrator to check meeting connections.'
}

export function useCallConnectionHelp(channelJoined: boolean, waitingPeers: number): string | null {
  const waiting = !channelJoined || waitingPeers > 0
  const [slow, setSlow] = useState(false)
  useEffect(() => {
    setSlow(false)
    if (!waiting) return
    const timer = window.setTimeout(() => setSlow(true), 8_000)
    return () => window.clearTimeout(timer)
  }, [waiting])
  return slow && waiting ? connectionHelp(channelJoined, waitingPeers, 8_000) : null
}
